import React, { useMemo } from "react";
import AreaChart from "../charts/AreaChart";
import { fmt$Compact } from "../../utils/format";

const monthAbbr = (full) => (typeof full === "string" ? full.slice(0, 3) : "");

const NetInflowPanel = ({ yearlyData }) => {
  const series = useMemo(() => {
    if (!Array.isArray(yearlyData) || yearlyData.length === 0) return [];
    const currentYear = new Date().getFullYear();
    let entry = yearlyData.find((y) => y.year === currentYear);
    if (!entry) {
      const sorted = [...yearlyData].sort((a, b) => b.year - a.year);
      entry = sorted.find((y) => y.months?.some((m) => (m.totalInvestment || 0) > 0));
    }
    if (!entry?.months) return [];
    return entry.months.map((m) => ({
      label: monthAbbr(m.month),
      value: Number(m.totalInvestment || 0),
    }));
  }, [yearlyData]);

  const total = series.reduce((s, d) => s + d.value, 0);

  return (
    <section className="card">
      <header className="card__head">
        <h2 className="card__title">Net inflow</h2>
        <span className="card__sub">YTD · USD</span>
      </header>
      <div className="card__body card__body--flush">
        <div className="chart-stat">
          <div>
            <div className="chart-stat__num">{fmt$Compact(total)}</div>
            <div className="chart-stat__legend">
              <span><i />Monthly investment</span>
            </div>
          </div>
        </div>
        <div style={{ padding: "12px 8px 8px" }}>
          <AreaChart data={series} height={200} />
        </div>
      </div>
    </section>
  );
};

export default NetInflowPanel;
